/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalPartyResponse as ModelsV3LoanManagementExternalPartyResponse } from '../../models/Models/v3/LoanManagement/external-party-response';

export interface V3LoanManagementExternalPartiesExternalPartyGet$Plain$Params {
  id?: string;
  email?: string;
}

export function v3LoanManagementExternalPartiesExternalPartyGet$Plain(http: HttpClient, rootUrl: string, params?: V3LoanManagementExternalPartiesExternalPartyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3LoanManagementExternalPartyResponse>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementExternalPartiesExternalPartyGet$Plain.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3LoanManagementExternalPartyResponse>;
    })
  );
}

v3LoanManagementExternalPartiesExternalPartyGet$Plain.PATH = '/v3/loan-management/external-parties/external-party';
